
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 12 16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#000","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M8.43 5h2.14c.174 0 .33-.14.397-.355a.723.723 0 00-.093-.625l-2.14-2.852c-.122-.164-.308-.213-.468-.124-.161.088-.266.298-.266.53v2.852c0 .317.193.574.43.574z"}}),_c('path',{attrs:{"d":"M11.542 5h-3.42c-.51 0-.922-.43-.922-.961V.477A.468.468 0 006.742 0H1.44C.654 0 0 .663 0 1.482V14.5c0 .819.654 1.5 1.44 1.5h9.12c.786 0 1.44-.681 1.44-1.5V5.477A.468.468 0 0011.542 5zM8.64 10.5a.49.49 0 01-.48.5H6.72v1.5a.49.49 0 01-.48.5.49.49 0 01-.48-.5V11H4.32a.49.49 0 01-.48-.5c0-.277.215-.5.48-.5h1.44V8.5c0-.276.215-.5.48-.5a.49.49 0 01.48.5V10h1.44a.49.49 0 01.48.5z","fill-rule":"nonzero"}})])])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/management/upload_file.svg